(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petpro-cart-complements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('petpro-cart-complements')) {
    customElements.define('petpro-cart-complements', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.onChange = event => {
          const select = event.target.closest('.pp-complement-select');
          if (!select) return;
          const option = select.selectedOptions[0];
          const card = select.closest('.pp-complement');
          card.querySelector('.pp-complement-price').textContent = option.dataset.price;
          card.querySelector('.pp-complement-link').href = option.dataset.url;
        };
        this.onSubmit = event => {
          const form = event.target.closest('form');
          if (!form) return;
          if (form.dataset.submitting) { event.preventDefault(); return; }
          form.dataset.submitting = 'true';
          const button = form.querySelector('[type="submit"]');
          button.disabled = true;
          button.textContent = this.dataset.addingLabel;
        };
        this.onPageShow = event => {
          if (!event.persisted) return;
          this.querySelectorAll('form').forEach(form => {
            delete form.dataset.submitting;
            const button = form.querySelector('[type="submit"]');
            button.disabled = false;
            button.textContent = this.dataset.addLabel;
          });
          this.scheduleRefresh();
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);
        this.observer = new MutationObserver(() => this.scheduleRefresh());
        const items = document.getElementById('main-cart-items');
        if (items) this.observer.observe(items, {childList:true,subtree:true});
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.scheduleRefresh());
        }
      }
      scheduleRefresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 150);
      }
      async refresh() {
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        try {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal:request.signal});
          if (!response.ok) throw new Error('section_unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector('petpro-cart-complements');
          if (!next || request.signal.aborted || !this.isConnected) return;
          this.innerHTML = next.innerHTML;
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            this.querySelector('.pp-complements-inner')?.setAttribute('hidden', '');
          }
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.unsubscribe?.();
        this.request?.abort();
        clearTimeout(this.refreshTimer);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-food-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-food-banners')) {
  customElements.define('pp-food-banners', class extends HTMLElement {
    connectedCallback() {
      this.lists = [...this.querySelectorAll('.pp-food-card__chips')];
      this.titles = [...this.querySelectorAll('.pp-food-card__title')];
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      document.fonts?.ready.then(() => this.fit());
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    fitTitles() {
      if (!this.titles.length) return;
      this.titles.forEach(title => { title.style.fontSize = ''; });
      const probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;top:0;left:0;visibility:hidden;white-space:nowrap';
      let scale = 1;
      const bases = this.titles.map(title => {
        const words = title.textContent.trim().split(/\s+/);
        title.appendChild(probe);
        let widest = 0;
        words.forEach(word => {
          probe.textContent = word;
          widest = Math.max(widest, probe.getBoundingClientRect().width);
        });
        probe.remove();
        const room = title.closest('.pp-food-card__content').clientWidth - 1;
        if (widest > room) scale = Math.min(scale, room / widest);
        return parseFloat(getComputedStyle(title).fontSize);
      });
      if (scale < 1) {
        this.titles.forEach((title, index) => {
          title.style.fontSize = Math.max(18, Math.floor(bases[index] * scale * 10) / 10) + 'px';
        });
      }
    }
    fitChips() {
      if (!this.lists.length) return;
      const counts = this.lists.map(list => {
        const items = [...list.children];
        items.forEach(item => { item.hidden = false; });
        if (!items.length) return Infinity;
        const top = items[0].offsetTop;
        return items.filter(item => item.offsetTop <= top + 2).length;
      });
      const visible = Math.min(...counts);
      this.lists.forEach(list => {
        [...list.children].forEach((item, index) => { item.hidden = index >= visible; });
      });
    }
    fit() {
      this.fitTitles();
      this.fitChips();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-home-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('petpro-brand-gallery')) {
  customElements.define('petpro-brand-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const track = this.querySelector('.pp-brands__logos');
      const collator = new Intl.Collator('es-PE', {numeric: true, sensitivity: 'accent'});
      const cards = Array.from(track.querySelectorAll(':scope > .pp-brand-directory__card'));
      cards.sort((a, b) => collator.compare(a.querySelector('strong')?.textContent.trim() || '', b.querySelector('strong')?.textContent.trim() || ''));
      track.append(...cards);
      const buttons = this.querySelectorAll('button[data-direction]');
      const update = () => { buttons[0].disabled = track.scrollLeft <= 2; buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}), {signal: this.abort.signal}));
      track.addEventListener('scroll', update, {passive:true, signal:this.abort.signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-home-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('petpro-featured-carousel')) {
  customElements.define('petpro-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.abortController) return;
      this.track = this.querySelector('.pp-home-products__grid');
      this.controls = this.querySelector('.pp-home-products__controls');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.controls) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
        } else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }
    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const visible = Math.max(1, Math.round((this.track.clientWidth + parseFloat(getComputedStyle(this.track).columnGap)) / step));
      this.track.scrollBy({ left: direction * step * visible, behavior: this.behavior() });
    }
    updateControls() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = end <= 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= end - 2;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
